export const environment = {
  production: false,
  appName: 'Diaspora Financing',
  appShortName: 'Diaspora',
  baseApiUrl: '/api/',
  mapsAccessToken:
    'pk.eyJ1IjoicmljaGFyZHBlbnJvc2UiLCJhIjoiY2xmNDVkMWR1MGlxazN2bzF2cWhrZG9ibSJ9.dL4agGcHuoV7eQ5cjko1aw',
  useFakeLogin: true,
  useLocal: true,
  baseUrl: '/',
  baseHRef: '',
};
